// extracted by mini-css-extract-plugin
export default {"menuBlock":"bF-z","title":"cF-z","nav":"dF-z","flexCell":"eF-z","facetLink":"fF-z"};